module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Up-down-217a6953eb2407dee9f152e9425df142.svg";